import CustomersBalanceReport from "./CustomersBalanceReport";
import customerStatementReport from "./customerStatementReport";
import paymentDetailsReport from "./paymentDetailsReport";

export default {
    namespaced: true,
    modules: {
        customerStatement: customerStatementReport,
        paymentDetails: paymentDetailsReport,
        customersBalance: CustomersBalanceReport
    }
}